/**
 * Só aceita caminho relativo do próprio app ("/algo"). Rejeita URLs absolutas, "//host" e "/\\host"
 * (open redirect: levaria a senha digitada para um site de phishing).
 */
export function safeRedirectPath(from: string | null | undefined): string {
  if (!from || !from.startsWith("/") || from.startsWith("//") || from.startsWith("/\\")) return "/";
  if (/[\u0000-\u001f\\]/.test(from)) return "/";
  return from;
}
